import { useState, useEffect } from 'react';
import fhirpath from 'fhirpath';
import fhirpath_r4_model from 'fhirpath/fhir-context/r4';

export const useFormPrefs = (settings, fhirClient, patientId, formId) => {
	const [isLoadingPrefs, setIsLoadingPrefs] = useState(false);
	const [formPrefs, setFormPrefs] = useState(JSON.parse(JSON.stringify(settings?.features)));

	useEffect(() => {
		if (fhirClient.isLoaded && patientId && formId) {
			let featuresJson = JSON.parse(JSON.stringify(settings?.features));

			if (!isLoadingPrefs) {
				setIsLoadingPrefs(true);

				//fetch('/formprefs.json').then(data => data.json()).then((json) => {
				fhirClient.client.request(`QuestionnaireResponse/formpref?patientId=${patientId}&formId=${formId}`).then((json) => {
					json.item.forEach((value) => {
						const path = `QuestionnaireResponse.item.where(linkId='${value.linkId}').answer.value`;
						featuresJson[value.linkId] = fhirpath.evaluate(json, path, null, fhirpath_r4_model).shift();
					});

					setFormPrefs(featuresJson);
					setIsLoadingPrefs(false);
				});
			}
		}
	}, [fhirClient.isLoaded, formId, patientId]);

	return formPrefs;
}
